import React from 'react';

import { COMPLETED } from '@/const/productStatus';
import { formatPrice } from '@/utils/common';

export interface MyProductPriceProps {
  product: ProductDetailResponse;
  className?: string;
}

export default function MyProductPrice({ product, className }: MyProductPriceProps) {
  const isShowActualSalePrice = () => {
    return !!product.status && COMPLETED == product.status.code && !!product.actualSalePrice;
  };

  return (
    <span className={className}>
      {isShowActualSalePrice() ? (
        <>{formatPrice(String(product.actualSalePrice))}</>
      ) : (
        product.price && <>{formatPrice(String(product.price))}</>
      )}
    </span>
  );
}
